<div class="connection-testing-dialog">
  <!-- Loading state -->
  @if (state() === "loading") {
    <div class="spinner-container">
      <mat-spinner diameter="48" class="testing-spinner"></mat-spinner>
    </div>
    <h2 class="modal-title">Testing in progress</h2>
    <p class="modal-message">
      Currently running tests of connection
      <strong>{{ data.connectionName }}</strong
      >.
    </p>
    <p class="modal-hint">This may take up to 20 minutes.</p>
    <button mat-button class="close-button" (click)="onClose()">Close</button>
  }

  <!-- Success state -->
  @if (state() === "success") {
    <mat-icon class="success-icon">check_circle</mat-icon>
    <h2 class="modal-title">Testing completed</h2>
    <div class="result-row success-result">
      <mat-icon class="result-icon success-icon-small">check_circle</mat-icon>
      <span class="result-label">Success</span>
      <span class="result-detail">{{ successMessage() }}</span>
    </div>
    <button
      mat-flat-button
      color="primary"
      class="done-button"
      (click)="onClose()"
    >
      Done
    </button>
  }

  <!-- Error state (same purple checkmark as success = "testing completed", error details below) -->
  @if (state() === "error") {
    <mat-icon class="success-icon">check_circle</mat-icon>
    <h2 class="modal-title">Testing completed</h2>
    <div class="result-row error-result">
      <mat-icon class="result-icon error-icon-small">cancel</mat-icon>
      <span class="result-label">Error</span>
      <span class="result-detail">{{ errorMessage() }}</span>
    </div>
    <button
      mat-flat-button
      color="primary"
      class="done-button"
      (click)="onClose()"
    >
      Done
    </button>
  }
</div>
